export default __webpack_public_path__ + "static/media/principal-banner-eng.c4bad1b8.png";